import type { SdkClient } from '../core/client.ts';
import type { DemoLogEntry, DemoScript } from '../core/demo-transport.ts';

export interface DevModule {
  /** Every operation this session attempted, with its outcome. */
  log(): DemoLogEntry[];
  /** Script demo-mode outcomes: fill, skip, error, quota, cancellation. */
  simulate(script: DemoScript): void;
  /** Force one error code on the next matching call, then clear it. */
  forceError(code: string, match?: string): void;
  isDemo(): boolean;
  capabilities(): string[];
  session(): unknown;
}

export function createDevModule(client: SdkClient): DevModule {
  return {
    log() {
      return client.demoLog();
    },

    simulate(script) {
      client.configureDemo(script);
    },

    forceError(code, match) {
      client.configureDemo({ nextError: { code, match } });
    },

    isDemo() {
      return client.isDemo;
    },

    capabilities() {
      return client.capabilities.list();
    },

    session() {
      return client.currentSession;
    },
  };
}
